import React from 'react';
import { Button, Typography, Box, Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Container, Card, CardContent, Paper } from '@mui/material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';

const NotFoundPage = () => {
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);
  const history = useHistory();
  return (
    <Container
      component='main'
      maxWidth='md'
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh'
      }}
    >
      <Paper elevation={3} sx={{ p: 5, textAlign: 'center', borderRadius: 3 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2
          }}
        >
          <AnnouncementOutlinedIcon
            sx={{ fontSize: 70, color: 'error.main' }}
          />
          <Typography
            variant='h2'
            sx={{ color: 'primary.main', fontSize: '58' }}
          >
            404
          </Typography>
          <Typography
            sx={{ fontSize: 20 }}
            variant='button'
            color='textSecondary'
          >
            Oops! The page you’re looking for doesn’t exist.
          </Typography>
          <Button
            variant='contained'
            color='primary'
            sx={{ mt: 2, borderRadius: 2 }}
            onClick={() => history.push('/')}
          >
            Go to Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh',
    backgroundColor: '#f5f5f5'
  },
  box: {
    textAlign: 'center',
    padding: 4,
    backgroundColor: 'white',
    borderRadius: 2,
    boxShadow: 3
  },
  heading: {
    fontWeight: 'bold',
    color: '#1976d2'
  },
  subHeading: {
    marginBottom: 2,
    color: '#666'
  },
  linkBox: {
    marginTop: 3,
    textAlign: 'center'
  },
  button: {
    backgroundColor: '#1976d2',
    '&:hover': {
      backgroundColor: '#1565c0'
    }
  }
};

export default NotFoundPage;
